import React, { useEffect, useState, lazy, Suspense } from 'react';
import { useFeatureFlags } from 'components/shared/hooks';
import { Button } from '@seismic/mantle';
import {
  LearningContent,
  PracticeContent,
} from '@seismic/common-content-model-v2/dist/content-model-v2/contents/thin-models/';
import classNames from 'classnames';
import { getSeismicAuthToken } from 'utils/centralAuthToken';
import { getService, ServiceAddressService } from '@seismic/browser-services';
import withBrowserServices from 'utils/withBrowserServices';
import { LoadingButton } from './LoadingButton';

const UniversalDownloadComponent = lazy(() =>
  import(
    /* webpackChunkName: "UDC" */ '@seismic/universal-download-component'
  ).then(module => ({
    default: module.UniversalDownloadComponent,
  })),
);

const VideoDownloadButton = withBrowserServices(props => {
  const [seismicAuthToken, setSeismicAuthToken] = useState(null);
  const [caugsServiceUrl, setCaugsServiceUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  const IsSeismicDownloadVideo = useFeatureFlags([
    'readiness-enable-seismic-download-video',
  ]);

  let item = null;
  const { type, id, repository } = props.item;

  if (repository === 'Practice') {
    item = PracticeContent.create(type, id);
  } else {
    item = LearningContent.create(type, id);
  }

  const items = [item];

  const componentAs = props.componentAs || Button;

  const className =
    componentAs === Button
      ? classNames('udc-button-as-link', {
          'udc-button-as-link-with-channels': props.isPostToChannels,
          'udc-button-as-link-with-try-again': props.isTryAgain,
        })
      : '';

  const { beforeDownload, onDownloadStart, onDownloadEnd, onError } =
    props.downloadCallbacks || {};

  const applicationWatermarkData = {
    Application: repository,
    ViewerId: props.currentUserId,
  };

  const filename = `Lesson_${repository}_${type}_${id}`;

  useEffect(() => {
    (async () => {
      const [token, serviceUrl] = await Promise.all([
        getSeismicAuthToken(),
        getService(ServiceAddressService).getServiceAddressByKey('caugs'),
      ]);
      setSeismicAuthToken(token);
      setCaugsServiceUrl(serviceUrl);
      setLoading(false);
    })();
  }, []);

  return (
    <>
      {IsSeismicDownloadVideo && (
        <Suspense fallback={<LoadingButton className={className} />}>
          {loading || props.disabled ? (
            <LoadingButton className={className} />
          ) : (
            <UniversalDownloadComponent
              componentAs={componentAs}
              className={className}
              downloadOptions={{
                applicationWatermarkData,
                filename,
                contentVersion: 2,
                token: () => seismicAuthToken,
                serviceUrl: caugsServiceUrl,
                beforeDownload,
                onDownloadStart,
                onDownloadEnd,
                onError,
              }}
              items={items}
              label={t('common.download')}
              useExternalTheme={false}
            />
          )}
        </Suspense>
      )}
    </>
  );
});

export default VideoDownloadButton;
